<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col>
        <router-link v-if="isFromMemberPage" :to="{ name: 'member_info_list' }" class="btn btn-ptc1" tag="button">返回</router-link>
      </b-col>
      <b-col class="text-center title">
        <span v-if="isFromMemberPage">會員管理 / 會員查詢 / 電子票券匣({{ specificMemberName }})</span>
        <span v-else>情報分析 / 電子票券匣</span>
      </b-col>
      <b-col>
        <div class="text-right">
          <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
      <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row">
                  <label class="control-label col-md-2 mt-2">票券名稱：</label>
                  <div class="col-md-3">
                    <input type="text" class="form-control" v-model="ticketName" placeholder="票券名稱">
                  </div>
                </div>
                <div class="row mt-2">
                  <label class="control-label col-md-2 mt-2">票券編號：</label>
                  <div class="col-md-3">
                    <input type="text" class="form-control" v-model="ticketCode" placeholder="票券編號">
                  </div>
                </div>
                <div class="row mt-2">
                  <label class="control-label col-md-2 mt-2">紀錄類型：</label>
                  <div class="col-md-3">
                    <select class="form-control" v-model="recordType">
                      <option value="current_tickets">可兌換票券</option>
                      <option value="used_tickets">使用記錄</option>
                      <option value="expired_tickets">過期票券</option>
                      <option value="transfer_event">轉贈紀錄</option>
                      <option value="active_give">活動紀錄</option>
                    </select>
                  </div>
                </div>
                <div class="row mt-2">
                  <label class="control-label col-md-2 mt-2">票券類型：</label>
                  <div class="col-md-3">
                    <select class="form-control" v-model.number="ticketType">
                      <option :value="0">全部</option>
                      <option v-for="x in ticketTypeList" :value="x.id" :key="x.id">{{x.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="row mt-2">
                  <label class="control-label col-md-2 mt-2">品牌：</label>
                  <div class="col-md-3">
                    <select class="form-control" v-model="brandCode">
                      <option value="">全部</option>
                      <option value="MWD">麥味登</option>
                      <option value="CM">炸雞大獅</option>
                      <option value="REAL">REAL</option>
                      <option value="SJ">涮金鍋</option>
                    </select>
                  </div>
                </div>
                <div class="row mt-2">
                  <label class="control-label col-md-2 mt-2">日期區間：</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="startDate">
                  </div>
                  <label class="mt-2">至</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="endDate">
                  </div>
                  <div class="col-md-3">
                    <button type="button" class="btn btn-success text-white mr-2" style="width: 88px; height: 38px;" @click="getTicketHistory(1)">查詢</button>
                    <button type="button" class="btn btn-success text-white" style="width: 88px; height: 38px;" @click="resetFilters">重置</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <table id="mytable" class="table table-bordred table-striped">
              <thead>
                <tr>
                  <th @click="sortBy('datetime')" style="cursor: pointer;">
                    時間
                    <i v-if="sortField === 'datetime'" :class="sortOrder === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
                  </th>
                  <th @click="sortBy('ticketInfo.name')" style="cursor: pointer;">
                    票券資訊
                    <i v-if="sortField === 'ticketInfo.name'" :class="sortOrder === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
                  </th>
                  <th>品牌</th>
                  <th>點數</th>
                  <th>張數</th>
                  <th v-if="recordType !== 'transfer_event'">來源</th>
                  <th>詳細資訊</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(record, index) in ticketHistoryList" :key="record.id">
                  <td>{{ formatDateTime(record.datetime) }}</td>
                  <td>
                    <div class="ticket-name">{{ record.ticketInfo.name }}</div>
                    <small class="text-muted ticket-code">{{ record.ticketInfo.code }}</small>
                    <br>
                    <small class="text-info ticket-category">{{ record.ticketInfo.category }}</small>
                    <br>
                    <small 
                      :class="recordType === 'expired_tickets' ? 'text-danger' : 'text-success'" 
                      v-if="record.ticketInfo.applicableStartAt && record.ticketInfo.applicableEndAt"
                      class="ticket-period">
                      使用期限: {{ formatDate(record.ticketInfo.applicableStartAt) }} ~ {{ formatDate(record.ticketInfo.applicableEndAt) }}
                    </small>
                  </td>
                  <td>{{ record.ticketInfo.brand }}</td>
                  <td>{{ record.points || 0 }} 點</td>
                  <td>{{ record.quantity || 0 }} 張</td>
                  <td v-if="recordType !== 'transfer_event'">
                    <span :class="getSourceClass(record)" style="white-space: pre-line;">{{ getDetailedSourceName(record) }}</span>
                  </td>
                  <td>
                    <!-- 活動紀錄不顯示狀態標籤 -->
                    <div v-if="recordType !== 'active_give'" class="mb-2">
                      <span :class="getStatusClass(record.detailInfo || record.status)">
                        {{ record.detailInfo || record.status }}
                      </span>
                    </div>
                    <div v-if="record.memberInfo && !isFromMemberPage" class="mb-2 detail-info-item">
                      <small>會員: {{ record.memberInfo.name }} ({{ record.memberInfo.mobile }})</small>
                      <br>
                      <small class="text-info">{{ record.memberInfo.grade }}</small>
                    </div>
                    <div v-if="record.storeInfo" class="mb-2 detail-info-item">
                      <small>門市: {{ record.storeInfo.name }}</small>
                    </div>
                    <div v-if="record.transferInfo" class="transfer-info-block">
                      <!-- 目前持有者資訊 -->
                      <div class="mb-2 detail-info-item">
                        <small>目前持有: {{ record.transferInfo.toMemberName || '未知' }}
                          <span v-if="record.transferInfo.toMemberMobile"
                                :title="record.transferInfo.toMemberMobile"
                                style="cursor: help;">
                            ({{ maskPhoneNumber(record.transferInfo.toMemberMobile) }})
                          </span>
                        </small>
                      </div>
                      <!-- 轉贈次數 -->
                      <div v-if="record.transferInfo.transferCount" class="mb-2 detail-info-item">
                        <small class="text-muted">轉贈 {{ record.transferInfo.transferCount }} 次</small>
                      </div>

                      <!-- 完整轉贈鏈按鈕 -->
                      <div v-if="record.transferInfo && record.transferInfo.toMemberId" class="mt-2">
                        <small>
                          <a href="javascript:void(0)"
                             @click="toggleFullChain(record)"
                             class="text-info chain-toggle-link">
                            <i :class="isFullChainExpanded(record.id) ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                            查看完整轉贈鏈
                          </a>
                        </small>
                      </div>

                      <!-- 展開的完整轉贈鏈 -->
                      <div v-if="isFullChainExpanded(record.id)" class="mt-2 full-chain">
                        <div v-if="loadingFullChain[record.id]" class="text-center">
                          <small class="text-muted">載入中...</small>
                        </div>
                        <div v-else-if="fullChainData[record.id] && fullChainData[record.id].length > 0">
                          <small class="text-muted chain-title">完整轉贈歷程：</small>
                          <div v-for="(node, idx) in getSortedChainData(record.id)" :key="idx" 
                               :class="['chain-node', { 'current-record': isCurrentRecord(record, node) }]">
                            <small>
                              <span class="chain-level">{{ idx + 1 }}.</span>
                              <span class="text-primary">{{ node.fromMemberName || '未知' }}</span>
                              <span class="text-muted">({{ maskPhoneNumber(node.fromMemberMobile) }})</span>
                              <i class="fa fa-arrow-right mx-1"></i>
                              <span class="text-success">{{ node.toMemberName || '未知' }}</span>
                              <span class="text-muted">({{ maskPhoneNumber(node.toMemberMobile) }})</span>
                              <br>
                              <span class="text-muted chain-time">
                                {{ formatDateTime(node.acceptedAt) }}
                              </span>
                            </small>
                          </div>
                        </div>
                        <div v-else-if="fullChainError[record.id]" class="text-center">
                          <small class="text-danger">{{ fullChainError[record.id] }}</small>
                        </div>
                        <div v-else class="text-center">
                          <small class="text-muted">無轉贈記錄</small>
                        </div>
                      </div>
                    </div>
                    <div v-if="record.activeGiveInfo" class="activity-info-block">
                      <div class="detail-info-item">
                        <small>活動: {{ record.activeGiveInfo.activityName }}</small>
                      </div>
                      <div v-if="record.activeGiveInfo.activeGiveId" class="detail-info-item">
                        <small>票券贈送 ID: {{ record.activeGiveInfo.activeGiveId }}</small>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="row" style="padding: 0 1rem" v-if="ticketHistoryList.length > 0">
              <div class="col-md-6">
                <select class="form-control" v-model.number="perPage" @change="getTicketHistory(1)" style="width: 100px; display: inline-block;">
                  <option :value="10">10</option>
                  <option :value="25">25</option>
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                </select>
                <label style="margin-left: 10px;">筆/頁</label>
              </div>
              <div class="col-md-6">
                <b-pagination
                  size="md"
                  :total-rows="totalCount"
                  v-model="currentPage"
                  :per-page="perPage"
                  @change="getTicketHistory"
                  class="float-right">
                </b-pagination>
              </div>
            </div>
            <div class="row" style="padding: 0 1rem" v-if="ticketHistoryList.length > 0">
              <label>{{ startRowNum }} 到 {{ endRowNum }}，總共 {{ totalCount }} 筆</label>
            </div>
            <div v-if="ticketHistoryList.length === 0 && !loading" class="text-center p-4">
              <p class="text-muted">查無資料</p>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import miniToastr from 'mini-toastr'
import axios from 'axios'
import { API_URL } from '../../../store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'

export default {
  name: 'TicketHistoryList',
  data() {
    return {
      // 篩選條件
      memberSearch: '', // 保持空值，不進行會員搜尋
      ticketName: '', // 票券名稱搜尋
      ticketCode: '', // 票券編號搜尋
      startDate: '',
      endDate: '',
      recordType: 'current_tickets',
      ticketType: 0,
      brandCode: '', // 保持空值，不進行品牌篩選

      // 特定會員篩選（從會員管理頁面跳轉時使用）
      specificMemberId: null,
      specificMemberName: '',
      specificMemberPhone: '',
      specificMemberGrade: '',
      isFromMemberPage: false,

      // 資料列表
      ticketHistoryList: [],
      ticketTypeList: [],

      // 分頁
      currentPage: 1,
      perPage: 25,
      totalCount: 0,
      totalPages: 0,
      startRowNum: 0,
      endRowNum: 0,

      // 排序
      sortField: 'datetime',
      sortOrder: 'desc',

      // 狀態
      loading: false,

      // 完整轉贈鏈展開狀態
      expandedFullChains: {},
      fullChainData: {},
      loadingFullChain: {},
      fullChainError: {}
    }
  },
  created() {
    this.setDefaultDateRange()
    this.loadTicketTypes()

    // 檢查是否從會員管理頁面跳轉過來，如果有則設定會員篩選
    if (this.$route.params.memberid && this.$route.params.membername) {
      this.specificMemberId = this.$route.params.memberid
      this.specificMemberName = this.$route.params.membername
      this.specificMemberPhone = this.$route.params.memberphone || ''
      this.specificMemberGrade = this.$route.params.membergrade || ''
      this.isFromMemberPage = true
    }

    this.getTicketHistory(1)

    // 功能權限檢查
    this.FunctionPermission = getFunctionPermission('F13') // 使用與coupon相同的權限代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
    }
  },
  methods: {
    // 重置篩選條件
    resetFilters() {
      this.ticketName = ''
      this.ticketCode = ''
      this.recordType = 'current_tickets'
      this.ticketType = 0
      this.brandCode = ''
      this.setDefaultDateRange()
      this.getTicketHistory(1)
    },

    // 設定預設日期範圍（最近3個月）
    setDefaultDateRange() {
      const today = new Date()
      const threeMonthsAgo = new Date()
      threeMonthsAgo.setMonth(today.getMonth() - 3)

      this.startDate = this.formatDate(threeMonthsAgo)
      this.endDate = this.formatDate(today)
    },

    // 日期格式化
    formatDate(date) {
      if (!date) return ''

      // 如果是字串，先轉換為 Date 物件
      if (typeof date === 'string') {
        date = new Date(date)
      }

      // 檢查是否為有效日期
      if (isNaN(date.getTime())) return ''

      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).substr(-2, 2)
      const day = ('0' + date.getDate()).substr(-2, 2)
      return `${year}-${month}-${day}`
    },

    // 日期時間格式化（24小時制）
    formatDateTime(datetime) {
      if (!datetime) return ''
      const date = new Date(datetime)

      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + date.getDate()).slice(-2)
      const hour = ('0' + date.getHours()).slice(-2)
      const minutes = ('0' + date.getMinutes()).slice(-2)
      const seconds = ('0' + date.getSeconds()).slice(-2)

      return `${year}/${month}/${day} ${hour}:${minutes}:${seconds}`
    },

    // 載入票券類型下拉選單
    loadTicketTypes() {
      this.loading = true
      axios.post(API_URL + '/web/ticket/querydropdown')
        .then((response) => {
          if (response.data.result === '0000') {
            this.ticketTypeList = response.data.data.poscategory || []
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.data.message, '載入票券類型失敗')
          }
          this.loading = false
        })
        .catch((error) => {
          console.error('載入票券類型錯誤:', error)
          miniToastr.error('載入票券類型失敗', '錯誤')
          this.loading = false
        })
    },

    // 查詢票券歷程
    getTicketHistory(page) {
      if (this.startDate && this.endDate && this.startDate > this.endDate) {
        miniToastr.error('請選擇正確的日期區間')
        return
      }

      this.loading = true
      this.$parent.Loading = true

      const params = {
        memberSearch: this.isFromMemberPage ? '' : this.memberSearch, // 如果是從會員頁面來的，不使用文字搜尋
        memberid: this.isFromMemberPage ? parseInt(this.specificMemberId) || 0 : 0, // 改為小寫，確保是數字
        ticketName: this.ticketName, // 票券名稱搜尋
        ticketCode: this.ticketCode, // 票券編號搜尋
        startDate: this.startDate,
        endDate: this.endDate,
        recordType: this.recordType,
        ticketType: parseInt(this.ticketType) || 0, // 確保是數字
        brandCode: this.brandCode,
        page: parseInt(page) || 1, // 確保是數字
        pageSize: parseInt(this.perPage) || 25, // 確保是數字
        sortField: this.sortField,
        sortOrder: this.sortOrder
      }

      return axios.post(API_URL + '/web/member/ticket-history/v1', params)
        .then((response) => {
          if (response.data.result === '0000') {
            this.ticketHistoryList = response.data.data.items || []
            this.currentPage = page
            this.totalCount = response.data.data.pagination.totalCount || 0
            this.totalPages = response.data.data.pagination.totalPages || 0

            // 驗證返回的記錄是否都屬於指定會員
            if (this.isFromMemberPage && this.specificMemberId) {
              const expectedMemberId = parseInt(this.specificMemberId)
              const wrongMemberRecords = this.ticketHistoryList.filter(item => 
                item.memberInfo && item.memberInfo.id !== expectedMemberId
              )
              
              if (wrongMemberRecords.length > 0) {
                console.error('錯誤記錄詳情:', wrongMemberRecords.map(r => ({
                  id: r.id,
                  memberName: r.memberInfo.name,
                  memberId: r.memberInfo.id,
                  ticketName: r.ticketInfo.name
                })))
              } else {
                console.log('所有記錄都屬於正確的會員 (ID:', expectedMemberId, ')')
              }
            }

            // 計算顯示範圍
            this.startRowNum = this.totalCount === 0 ? 0 : (this.currentPage - 1) * this.perPage + 1
            this.endRowNum = Math.min(this.currentPage * this.perPage, this.totalCount)

            // 更新 JWT token
            if (response.data.jwt) {
              this.$store.commit('TOKEN', response.data.jwt)
            }
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message || '查詢失敗', '查詢失敗')
            console.error('查詢失敗:', response.data.message)
          }
          this.loading = false
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.error('查詢錯誤:', error)
          miniToastr.error('查詢失敗，請稍後再試', '查詢失敗')
          this.loading = false
          this.$parent.Loading = false
        })
    },

    // 排序功能
    sortBy(field) {
      if (this.sortField === field) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortField = field
        this.sortOrder = 'asc'
      }
      this.getTicketHistory(1)
    },

    // 取得紀錄類型名稱
    getRecordTypeName(recordType) {
      const typeMap = {
        'ticket': '票券紀錄',
        'transfer_event': '轉贈紀錄',
        'active_give': '活動贈送',
        'active_give_member': '活動贈送'
      }
      return typeMap[recordType] || recordType
    },

    // 取得紀錄類型樣式
    getRecordTypeClass(recordType) {
      const classMap = {
        'ticket': 'badge badge-primary',
        'transfer_event': 'badge badge-info',
        'active_give': 'badge badge-success',
        'active_give_member': 'badge badge-warning'
      }
      return classMap[recordType] || 'badge badge-secondary'
    },

    // 取得狀態樣式
    getStatusClass(status) {
      if (!status) return 'badge badge-secondary'

      // 轉贈事件狀態的精確匹配
      if (status === '已轉贈') {
        return 'badge badge-success'
      } else if (status === '發起') {
        return 'badge badge-info'
      } else if (status === '失敗') {
        return 'badge badge-danger'
      } else if (status === '取消') {
        return 'badge badge-warning'
      } else if (status === '已過期') {
        return 'badge badge-secondary'
      }

      // 其他一般狀態的模糊匹配
      if (status.includes('已使用') || status.includes('已兌換') || status.includes('已接受') || status.includes('已轉贈') || status.includes('已贈送')) {
        return 'badge badge-success'
      } else if (status.includes('未使用') || status.includes('可兌換') || status.includes('待接受') || status.includes('未贈送')) {
        return 'badge badge-warning'
      } else if (status.includes('已過期') || status.includes('已取消') || status.includes('失敗')) {
        return 'badge badge-secondary'
      } else {
        return 'badge badge-info'
      }
    },

    // 根據票券代碼取得品牌名稱
    getBrandName(ticketCode) {
      if (!ticketCode) return ''

      // 根據票券代碼前綴判斷品牌
      if (ticketCode.startsWith('MWD')) {
        return 'MWD'
      } else if (ticketCode.startsWith('CM')) {
        return 'CM'
      } else if (ticketCode.startsWith('REAL')) {
        return 'REAL'
      } else if (ticketCode.startsWith('SJ')) {
        return 'SJ'
      } else {
        return '' // 空的話不顯示任何內容
      }
    },

    // 取得來源名稱
    getSourceName(recordType) {
      const sourceMap = {
        'ticket': '兌換',
        'transfer_event': '轉贈',
        'active_give': '贈送',
        'active_give_member': '贈送'
      }
      return sourceMap[recordType] || '其他'
    },

    // 取得詳細來源名稱（細分活動贈送類型）
    getDetailedSourceName(record) {
      // 轉贈記錄
      if (record.transferInfo) {
        return '轉贈'
      }
      
      // 活動贈送 - 根據 give_type 細分
      if (record.activeGiveInfo && record.activeGiveInfo.giveType) {
        switch(record.activeGiveInfo.giveType) {
          case 1: return '新會員\n贈送'
          case 2: return '生日禮\n贈送'
          case 3: return '正式會員\n贈送'
          case 4: return '單一會員\n贈送'
          case 5: return '批次匯入\n贈送'
          case 6: return '總部系統\n贈送'
          case 7: return '問卷\n贈送'  // 預留給未來使用
          default: return '贈送'
        }
      }
      
      // 使用 record.source 或根據 recordType 判斷
      if (record.source) {
        return record.source
      }
      
      return this.getSourceName(record.recordType)
    },

    // 取得來源樣式
    getSourceClass(record) {
      // 如果有 activeGiveInfo，所有贈送類型都用綠色
      if (record.activeGiveInfo && record.activeGiveInfo.giveType) {
        return 'badge badge-success'  // 所有贈送類型統一綠色
      }

      // 轉贈
      if (record.transferInfo) {
        return 'badge badge-info'
      }

      // 使用 record.source 判斷
      const source = record.source || record.recordType
      
      // 如果傳入的是新的來源類型（中文）
      if (source === '兌換') {
        return 'badge badge-primary'
      } else if (source === '轉贈') {
        return 'badge badge-info'
      } else if (source === '贈送') {
        return 'badge badge-success'
      }

      // 向下兼容舊的 recordType
      const classMap = {
        'ticket': 'badge badge-primary',        // 兌換 - 藍色
        'transfer_event': 'badge badge-info',   // 轉贈 - 淺藍色
        'active_give': 'badge badge-success',   // 贈送 - 綠色
        'active_give_member': 'badge badge-success' // 贈送 - 綠色
      }
      return classMap[source] || 'badge badge-secondary'
    },

    // 遮蔽電話號碼中間部分
    maskPhoneNumber(phone) {
      if (!phone || phone.length < 6) return phone

      // 保留前2位和後3位，中間用*號遮蔽
      const start = phone.substring(0, 2)
      const end = phone.substring(phone.length - 3)
      const middle = '*'.repeat(phone.length - 5)

      return start + middle + end
    },

    // 切換完整轉贈鏈展開/收合
    async toggleFullChain(record) {
      const recordId = record.id

      if (this.expandedFullChains[recordId]) {
        // 收起
        this.$set(this.expandedFullChains, recordId, false)
      } else {
        // 展開：如果還沒載入資料，先呼叫 API
        if (!this.fullChainData[recordId]) {
          await this.loadFullChain(record)
        }
        this.$set(this.expandedFullChains, recordId, true)
      }
    },

    // 載入完整轉贈鏈
    async loadFullChain(record) {
      const recordId = record.id

      // 設定載入狀態
      this.$set(this.loadingFullChain, recordId, true)
      this.$set(this.fullChainError, recordId, null)

      try {
        const response = await axios.post(API_URL + '/web/member/ticket-history/full-chain/v1', {
          certificateSn: record.transferInfo.giftCertificateSn || record.ticketInfo.code,
          currentMemberId: record.transferInfo.toMemberId
        })

        if (response.data.result === '0000') {
          this.$set(this.fullChainData, recordId, response.data.chain || [])

          // 更新 JWT token
          if (response.data.jwt) {
            this.$store.commit('TOKEN', response.data.jwt)
          }
        } else if (response.data.result === '0006') {
          this.$parent.logOut(true, true)
        } else {
          this.$set(this.fullChainError, recordId, response.data.message || '載入失敗')
          console.error('載入完整轉贈鏈失敗:', response.data.message)
        }
      } catch (error) {
        console.error('載入完整轉贈鏈錯誤:', error)
        this.$set(this.fullChainError, recordId, '載入失敗，請稍後再試')
      } finally {
        this.$set(this.loadingFullChain, recordId, false)
      }
    },

    // 檢查完整轉贈鏈是否展開
    isFullChainExpanded(recordId) {
      return this.expandedFullChains[recordId] || false
    },

    // 取得排序後的轉贈鏈資料（從最早到最新，編號 1-4）
    getSortedChainData(recordId) {
      const chainData = this.fullChainData[recordId]
      if (!chainData || chainData.length === 0) {
        return []
      }
      // 按 level 降序排列（level 越大越早，所以降序後就是從早到晚）
      return [...chainData].sort((a, b) => b.level - a.level)
    },

    // 從 record.id 提取轉贈 ID（格式：transfer_123 -> 123）
    // 注意：此函數已不再使用，保留以備未來需要
    extractTransferId(recordId) {
      if (!recordId) return ''
      // recordId 格式為 "transfer_123"，提取數字部分
      const parts = recordId.split('_')
      return parts.length > 1 ? parts[1] : recordId
    },

    // 判斷是否為當前記錄（用於完整轉贈鏈中標記）
    isCurrentRecord(record, node) {
      if (!record || !node) return false
      
      // 比對轉贈 ID（node.id 對應後端的轉贈記錄 ID）
      if (record.transferInfo && record.transferInfo.transferId && node.id) {
        return node.id === record.transferInfo.transferId
      }
      
      // 比對時間（備用方案）
      if (record.datetime && node.acceptedAt) {
        const recordTime = new Date(record.datetime).getTime()
        const nodeTime = new Date(node.acceptedAt).getTime()
        // 允許 1 秒的誤差
        return Math.abs(recordTime - nodeTime) < 1000
      }
      
      return false
    }
  },
  watch: {
    // 監聽紀錄類型變化，切換時清空資料列表
    recordType() {
      this.ticketHistoryList = []
      this.totalCount = 0
      this.totalPages = 0
      this.currentPage = 1
    }
  }
}
</script>

<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}

.badge {
  font-size: 0.75em;
  padding: 0.25em 0.5em;
}

/* 表格樣式優化 */
.table {
  font-size: 14px;
}

.table th {
  background-color: #f8f9fa;
  font-weight: bold;
  padding: 12px 8px;
  vertical-align: middle;
}

.table td {
  padding: 14px 10px;
  vertical-align: top;
  line-height: 1.6;
}

.table tbody tr {
  border-bottom: 1px solid #e9ecef;
}

.table tbody tr:nth-child(odd) {
  background-color: #fafafa;
}

.table tbody tr:hover {
  background-color: #f5f5f5;
}

.table th[style*="cursor: pointer"]:hover {
  background-color: #e9ecef;
}

.text-muted {
  color: #6c757d !important;
  font-size: 0.9em;
}

.text-info {
  color: #17a2b8 !important;
  font-size: 0.9em;
}

.fa-sort-up, .fa-sort-down {
  margin-left: 5px;
}

/* 電話號碼 hover 效果 */
[title] {
  position: relative;
}

[title]:hover::after {
  content: attr(title);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  pointer-events: none;
}

[title]:hover::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(1px);
  border: 4px solid transparent;
  border-top-color: #333;
  z-index: 1000;
  pointer-events: none;
}

/* 完整轉贈鏈樣式 */
.full-chain {
  background-color: #e7f3ff;
  border-left: 3px solid #007bff;
  padding: 10px 12px;
  margin-top: 8px;
  border-radius: 4px;
  max-height: 400px;
  overflow-y: auto;
}

.chain-node {
  padding: 6px 0 6px 8px;
  border-bottom: 1px dashed #b3d9ff;
  line-height: 1.6;
  border-left: 3px solid transparent;
  margin-left: -8px;
  padding-left: 8px;
  transition: all 0.2s ease;
}

.chain-node:last-child {
  border-bottom: none;
}

/* 當前記錄標記 - 左側橙色標記線 */
.chain-node.current-record {
  border-left: 4px solid #ff9800;
  background-color: #fff3e0;
  font-weight: 600;
  padding-left: 12px;
  margin-left: -12px;
}

.chain-level {
  display: inline-block;
  min-width: 25px;
  font-weight: 600;
  color: #0056b3;
}

.full-chain .fa-arrow-right {
  color: #6c757d;
}

.full-chain .badge {
  font-size: 0.65em;
  padding: 0.2em 0.4em;
}

.full-chain::-webkit-scrollbar {
  width: 6px;
}

.full-chain::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.full-chain::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.full-chain::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* 使用期限顏色 */
.text-success {
  color: #28a745 !important;
}

.text-danger {
  color: #f05654 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/information/tickethistory/List.vue